import axios from "axios";

const API = axios.create({
	baseURL: process.env.REACT_APP_API_URL || "http://localhost:8000/api",
	timeout: 10000000,
	headers: {
		"Content-Type": "application/json",
		"Access-Control-Allow-Origin": "*",
	},
});

API.interceptors.response.use(
	(res) => {
		return res;
	},
	(err) => {
		const { status } = err.response;
		if (status === 401) {
			console.log("Unauthorized access - 401");
			// localStorage.clear();
			// window.location = "/login";
		}
		return Promise.reject(err);
	}
);

export default API;
